import request from 'utils/request';

export function fetchAsset(id: number): Promise<string> {
    return request(`/asset/${id}`, {
        responseType: 'arraybuffer',
    }).then((response) => Buffer.from(response.data, 'binary').toString('base64'));
}
